export default Object.freeze([
  'Город',
  'Село',
  'БОМЖ',
])
